import { MaterialIcon } from '@gorila-shared-ui/components';
import { Button } from 'baseui/button';
import { memo, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { isAllWorkspacesSelect, isPublicPageState } from '../../storage/app';
import { CurrentState } from '../../types/currentState';
import { StyledTooltip } from '../ui/StyledTooltip';
import ShareAssetsModal from './ShareAssetsModal';

type Props = Readonly<{
  currentState?: CurrentState;
}>;

function ShareAssetsButton({ currentState }: Props) {
  const [sharing, setSharing] = useState(false);
  const isAllWorkspacesSelected = useRecoilValue(isAllWorkspacesSelect);
  const isPublicPage = useRecoilValue(isPublicPageState);

  if (isAllWorkspacesSelected || isPublicPage) {
    return null;
  }

  return (
    <>
      <StyledTooltip
        content="Compartir"
        showArrow={false}
        placement="bottom"
        ignoreBoundary
      >
        <Button
          shape="circle"
          kind="tertiary"
          size="mini"
          onClick={() => setSharing(true)}
        >
          <MaterialIcon
            name="share"
            size="18px"
          />
        </Button>
      </StyledTooltip>
      {sharing && (
        <ShareAssetsModal
          isOpen
          onClose={() => setSharing(false)}
          assetId={currentState?.asset._id}
        />
      )}
    </>
  );
}

export default memo(ShareAssetsButton);
